'use strict';exports.__esModule = true;exports.mergeEntityProperties = exports.setEntityType = undefined;var _constants = require('../constants');

var setEntityType = exports.setEntityType = function setEntityType(entityType) {return function (entity) {return Object.assign({}, entity, { entityType: entityType });};};

var mergeEntityProperties = exports.mergeEntityProperties = function mergeEntityProperties(firstArray, secondArray) {var _ref =
  [
  firstArray.map(setEntityType(_constants.ENTITY_TYPES.PROPERTY)),
  secondArray.map(setEntityType(_constants.ENTITY_TYPES.PROJECT))],properties = _ref[0],projects = _ref[1];

  var result = [];
  var maxLength = Math.max(firstArray.length, projects.length);

  for (var i = 0; i < maxLength; i += 2) {
    if (i < properties.length) result.push(properties[i]);
    if (i < properties.length - 1) result.push(properties[i + 1]);
    if (i < projects.length) result.push(projects[i]);
    if (i < projects.length - 1) result.push(projects[i + 1]);
  }

  return result;
};


//////////////////
// WEBPACK FOOTER
// ./src/helpers/mergeEntityProperties.js
// module id = 3046
// module chunks = 0